import { Component, computed, input } from '@angular/core';
import { Booking } from '../../../core/models/entities/booking';

@Component({
  selector: 'app-booking-characteristic-icons',
  template: `
    @if (isRecurring()) {
      <i
        class="far fa-repeat shrink-0 opacity-70"
        data-cy="booking-recurring-icon"
      ></i>
    }
  `,
  host: { class: 'inline-flex shrink-0 items-center gap-1 empty:hidden' },
  standalone: false,
})
export class BookingCharacteristicIconsComponent {
  booking = input.required<Booking>();
  isRecurring = computed(() => !!this.booking().recurrence_rule);
}
